<template>
	<div>
		<van-form style="padding-bottom: 50px;">
			<van-field
				v-model="process_id_text"
				name="出差流程"
				label="出差流程"
				placeholder="选择出差流程"
				readonly
				@click="popup.process = true"
				:rules="[{ required: true, trigger: ' onBlur', message: '请选择出差流程' }]"
			/>
			<van-field
				v-model="form.start_date"
				name="开始日期"
				label="开始日期"
				placeholder="选择开始日期"
				readonly
				@click="popup.start_date = true"
				:rules="[{ required: true, trigger: ' onBlur', message: '请选择开始日期' }]"
			/>
			<van-field
				v-model="form.end_date"
				name="结束日期"
				label="结束日期"
				placeholder="选择结束日期"
				readonly
				@click="popup.end_date = true"
				:rules="[{ required: true, trigger: ' onBlur', message: '请选择结束日期' }]"
			/>
			<van-field
				v-model="form.day"
				name="出差天"
				type="number"
				label="出差天"
				placeholder="输入出差天"
				:rules="[{ required: true, trigger: 'onBlur', message: '请输入出差天' }]"
			/>
			<van-field
				v-model="form.hour"
				name="出差小时"
				type="number"
				label="出差小时"
				placeholder="输入出差小时"
				:rules="[{ required: true, trigger: 'onBlur', message: '请输入出差小时' }]"
			/>
			<van-field
				v-model="form.minute"
				name="出差分钟"
				type="number"
				label="出差分钟"
				placeholder="输入出差分钟"
				:rules="[{ required: true, trigger: 'onBlur', message: '请输入出差分钟' }]"
			/>
			<van-field
				v-model="form.cause"
				rows="3"
				autosize
				label="出差事由"
				type="textarea"
				placeholder="请输入出差事由"
				:rules="[{ required: true, trigger: 'onBlur', message: '请填写出差事由' }]"
			/>
			<div style="margin: 16px;">
				<van-button round block type="info" @click="onSubmit" native-type="submit">提交</van-button>
			</div>
		</van-form>

		<van-popup v-model="popup.process" position="bottom">
			<van-picker
				show-toolbar
				:columns="processList"
				@cancel="popup.process = false"
				@confirm="confirmProcess"
				value-key="process_name"
			/>
		</van-popup>
		<van-popup v-model="popup.start_date" position="bottom">
			<van-datetime-picker
				type="datetime"
				:min-date="minDate"
				:max-date="maxDate"
				@cancel="popup.start_date = false"
				@confirm="confirmStartTime"
			/>
		</van-popup>
		<van-popup v-model="popup.end_date" position="bottom">
			<van-datetime-picker
				type="datetime"
				:min-date="minDate"
				:max-date="maxDate"
				@cancel="popup.end_date = false"
				@confirm="confirmEndTime"
			/>
		</van-popup>
	</div>
</template>

<script>
import { getNowFormatDateTime } from "@/utils/tool";
import { getList } from "@/api/review";
import { Toast } from "vant";

export default {
	name: "travel",
	data() {
		return {
			type_id: this.$route.query.type,
			process_id: "",
			process_id_text: "",
			date: "",
			minDate: new Date(),
			maxDate: new Date(),
			form: {
				start_date: "",
				end_date: "",
				day: "",
				hour: "",
				minute: "",
				cause: ""
			},
			popup: {
				process: false,
				start_date: false,
				end_date: false
			},
			processList: []
		};
	},
	mounted() {
		this.getTravelList();
		this.findDate();
	},
	methods: {
		onSubmit() {
			if (
				this.form.start_date.replace("-", "/") >
				this.form.end_date.replace("-", "/")
			) {
				return Toast.fail("开始日期应小于结束日期");
			}
			this.$emit("sub", {
				requestType: "process_apply",
				process_id: this.process_id,
				apply_data: JSON.stringify(this.form),
				apply_rmb:  "0"
			});
		},
		getTravelList() {
			getList({
				requestType: "process_type",
				type_id: this.type_id
			})
				.then(res => {
					this.processList = res.obj;
				})
				.catch(err => {
					console.log(err);
					return Toast.fail("数据异常");
				});
		},
		clearForm() {
			for (var key in this.form) {
				if (key != "type" && key != "requestType") {
					this.form[key] = "";
				}
			}
			this.process_id_text = "";
			this.process_id = "";
			this.date = "";
		},
		findDate() {
			let now = new Date();
			now.setDate(now.getDate() + 30);
			this.maxDate = now;
		},
		confirmProcess(value) {
			this.process_id_text = value.process_name;
			this.process_id = value.process_id;
			this.popup.process = false;
		},
		confirmStartTime(val) {
			this.form.start_date = getNowFormatDateTime(val);
			this.popup.start_date = false;
		},
		confirmEndTime(val) {
			this.form.end_date = getNowFormatDateTime(val);
			this.popup.end_date = false;
		}
	}
};
</script>